import { render, staticRenderFns } from "./html-textarea.vue?vue&type=template&id=4ab9f1b0&scoped=true&"
import script from "./html-textarea.vue?vue&type=script&lang=js&"
export * from "./html-textarea.vue?vue&type=script&lang=js&"
import style0 from "./html-textarea.vue?vue&type=style&index=0&id=4ab9f1b0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9f1b0",
  null
  
)

export default component.exports